import styled from 'styled-components';

import { Toolbar } from '../../../slatePlugins/components/Toolbar/Toolbar';
import { colorsV2 } from '../../colors-v2';

export const StyledToolbar = styled(Toolbar)<{ $hidden; $theme; $arrow }>`
  position: fixed;
  z-index: 1000;
  > .toolbar {
    background-color: ${(p) => (p.$theme === 'light' ? colorsV2.white100 : colorsV2.black100)};
  }
`;
